<template>
    <div id="app" :class="'lng-'+$i18n.locale">
        <router-view></router-view>
    </div>
</template>
<script>
import Vue from 'vue';
export default {
    name: "app",
    data() {
        return {};
    },
    computed: {

    },
    methods: {

    },
    mounted() {}
};
</script>
<style lang="less">
#app {}
</style>